/**
 * ranks.ts — client-side FFR rank labels + colours, keyed by the server `k`
 * enum (server/src/roles.ts is the source of truth; this is for UI badges
 * without a round-trip). Lower k = higher rank.
 */
interface RankInfo { label: string; short: string; color: string; }

const TABLE: Record<number, RankInfo> = {
    0:  { label: 'Banned',                short: 'Banned',     color: '#FF0000' },
    1:  { label: 'Administrator',         short: 'Admin',      color: '#FF0000' },
    2:  { label: 'Game Manager',          short: 'GM',         color: '#FF6618' },
    3:  { label: 'Global Moderator',      short: 'Global Mod', color: '#FF6618' },
    4:  { label: 'Retired Staff',         short: 'Retired',    color: '#B4BBC4' },
    5:  { label: 'Forum Moderator',       short: 'Forum Mod',  color: '#E818FF' },
    6:  { label: 'Profile Moderator',     short: 'Profile Mod',color: '#E818FF' },
    7:  { label: 'Sectional Moderator',   short: 'Sect. Mod',  color: '#FF6618' },
    8:  { label: 'Developer',             short: 'Dev',        color: '#8f0cc7' },
    9:  { label: 'Event Staff',           short: 'Event',      color: '#0062ca' },
    10: { label: 'Simfile Judge',         short: 'Judge',      color: '#13CC23' },
    11: { label: 'Difficulty Consultant', short: 'Difficulty', color: '#13CC23' },
    12: { label: 'Simfile Author',        short: 'Simfile',    color: '#13CC23' },
    13: { label: 'Music Producer',        short: 'Music',      color: '#F7E138' },
    14: { label: 'Elite Keysmasher',      short: 'Elite',      color: '#63d644' },
    15: { label: 'Veteran',               short: 'Veteran',    color: '#7c83d4' },
    16: { label: 'User',                  short: 'User',       color: '#9b77cc' },
    99: { label: 'Anonymous',             short: 'Guest',      color: '#9b77cc' },
};

export function rankLabel(k: number): string { return TABLE[k]?.label ?? 'User'; }

// UI-only rank checks (the server re-derives + enforces authority from vB).
export function isAdminK(k: number): boolean { return k === 1; }
export function isModK(k: number): boolean { return k === 1 || k === 2 || k === 3 || k === 5 || k === 6 || k === 7; }

/** Badge for the roster: a short tag + colour, or null for plain users/guests. */
export function rankBadge(k: number): { short: string; color: string } | null {
    if (k === 16 || k === 99 || k === 0) return null;   // User / Anon / Banned → no badge
    const r = TABLE[k];
    return r ? { short: r.short, color: r.color } : null;
}
